import axiosInstance from "./axiosInstance";

export const fetchMailConfig = () => axiosInstance.get("/superadmin/mail-config");

export const updateMailConfig = (data) => axiosInstance.put("/superadmin/mail-config", data);

export const sendTestMailConfig = (data) => axiosInstance.post("/superadmin/mail-config/test", data);
